







import {Component, Prop, Vue} from 'vue-property-decorator'
import PolicyChapter from './PolicyChapter.vue'
import { IPolicyNode } from './model'

@Component({
  name: 'PolicyChapterTree',
  components: {
    PolicyChapter
  }
})
export default class PolicyChapterTree extends Vue {

  @Prop() readonly node!: IPolicyNode
  @Prop({ default: 1 }) readonly root?: number
  @Prop({ default: 0 }) readonly depth?: number

}
